//
//
//
//
//
//


export default {
  props: {
    productName: String
  }
}
